import type { RequestConfig } from '@customTypes/index';
import type { ArtistWorkHistoryDto } from '@customTypes/types';

import { api } from '@/shared/api/instance';

export type ArtistPostProfileWorkHistoryRequest = {
  profileId: string;
  workHistory: ArtistWorkHistoryDto;
};

type ConfirmEmailResponse = {
  message: string;
  confirmationCode: string;
};
export type ArtistPostProfileWorkHistoryParams =
  RequestConfig<ArtistPostProfileWorkHistoryRequest>;

export const artistPostProfileWorkHistory = async ({
  params,
  config
}: ArtistPostProfileWorkHistoryParams) =>
  api.post<ConfirmEmailResponse>(
    `/api/ArtistProfile/${params.profileId}/work-history`,
    params.workHistory,
    config
  );
